//Styles
import "../ServiceSearch.scss";
// Packages
import React from "react";
import { observer } from "mobx-react";
// Prime React
import { Panel } from "primereact/panel";
import { InputText } from "primereact/inputtext";
import { InputSwitch } from "primereact/inputswitch";
import { Button } from "primereact/button";
// Local
import ServiceSearchStore from "../ServiceSearchStore";
import { htmlInput } from "../../../utils/Helpers";

type Props = {};

export const SearchPanel: React.FC<Props> = observer((props: Props) => {    
    const handleSkipToSearch = (e: React.MouseEvent<HTMLAnchorElement> | React.KeyboardEvent<HTMLAnchorElement>) => {
        e.preventDefault();

        const targetPanel = document.getElementById("service-panel");
        if (!targetPanel) return;

        window.history.replaceState(null, "", "#service-panel");

        setTimeout(() => {
            targetPanel.focus();
        }, 0);
    };

    const isDisabled =
        ServiceSearchStore.searchIsEmpty() || ServiceSearchStore.isLoading;

    return (
      <>
      <a className="skip-link" href="#service-panel" onClick={handleSkipToSearch}
         onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
                handleSkipToSearch(e);
            }
         }}
      > 
        Skip to search
      </a>
      <section aria-labelledby="search-heading">
          <h2 id="search-heading">Search Services</h2>
          <div id="service-panel" tabIndex={-1}>
              <Panel id="service-search-panel" className="p-panel" header=" ">
                 <div className="p-fluid p-formgrid p-grid">
                    <div className="p-field p-col-6 p-md-6 p-sm-12 p-mt-4">
                       <span className="p-float-label">
                          <InputText
                             id="iServiceName"
                             type="text"
                             value={ServiceSearchStore.searchCriteria.name ?? ""}
                             onChange={(e) =>
                                ServiceSearchStore.update("name", htmlInput(e))
                             }
                          />
                          <label htmlFor="iServiceName">Party Name</label>
                       </span>
                    </div>
                    <div className="p-field p-col-6 p-md-6 p-sm-12 p-mt-4">
                       <span className="p-float-label">
                          <InputText
                             id="iServiceCaseNumber"
                             type="text"
                             value={ServiceSearchStore.searchCriteria.caseNumber ?? ""}
                             onChange={(e) =>
                                ServiceSearchStore.update("caseNumber", htmlInput(e))
                             }
                          />
                          <label htmlFor="iServiceCaseNumber">Case Number</label>
                       </span>
                    </div>
                    <div className="p-field p-col-6 p-md-6 p-sm-12 p-mt-1">
                       <span className="p-float-label">
                          <InputText
                             id="iParticipantName"
                             type="text"
                             value={
                                ServiceSearchStore.searchCriteria.participantName ?? ""
                             }
                             onChange={(e) =>
                                ServiceSearchStore.update(
                                   "participantName",
                                   htmlInput(e)
                                )
                             }
                          />
                          <label className="checkbox-label" htmlFor="iParticipantName">
                             Participant Name
                          </label>
                       </span>
                    </div>
                    <div className="p-field p-col-6 p-md-6 p-sm-12 p-mt-1">
                       <span className="p-float-label">
                          <InputText
                             id="iServiceAddress"
                             type="text"
                             value={
                                ServiceSearchStore.searchCriteria.serviceAddress ??
                                ""
                             }
                             onChange={(e) =>
                                ServiceSearchStore.update(
                                   "serviceAddress",
                                   htmlInput(e)
                                )
                             }
                          />
                          <label htmlFor="iServiceAddress">Service Address</label>
                       </span>
                    </div>
                    <div className="p-field p-col-12">
                      <p id="search-help" className="search-help-text">
                         Enter a search term to enable search
                      </p>
                    </div>
                    <div className="p-field p-col-4 p-md-4 p-sm-12 p-mt-2">
                        <div className="switch-field">
                            <input
                                id="include-closed-cases"
                                type="checkbox"
                                className="sr-only-switch"
                                aria-label="Include Closed Cases"
                                checked={ServiceSearchStore.searchCriteria.includeClosedCases ?? false}
                                onChange={(e) => {
                                    ServiceSearchStore.update("includeClosedCases", e.target.checked);
                                }}
                            />
                            <label
                                htmlFor="include-closed-cases"
                                className="switch-label"
                            >
                                <span className="switch-visual" />
                                <span className="checkbox-label">
                                    Include Closed Cases
                                </span>
                            </label>
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-3 p-sm-12 p-mt-4"></div>
                    <div className="p-field p-col-12 p-md-2 p-sm-12">
                        <Button
                            label="Clear"
                            className="p-button secondary"
                            onClick={() => ServiceSearchStore.clearSearchCriteria()}
                        />
                    </div>

                    <div className="p-field p-col-12 p-md-2 p-sm-12">
                        <Button
                            label="Search"
                            aria-disabled={isDisabled ? "true" : "false"}
                            aria-describedby="search-help"
                            onClick={(e) => {
                                if (isDisabled) {
                                    e.preventDefault();
                                    return;
                                }
                                ServiceSearchStore.searchServices();
                            }}
                        />
                    </div>
                 </div>
                 </Panel>
              </div>
          </section>
      </>
   );
});
